"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessControlRoleHash = exports.AccessControlRoleType = void 0;
var AccessControlRoleType;
(function (AccessControlRoleType) {
    AccessControlRoleType["DEFAULT_ADMIN_ROLE"] = "DEFAULT_ADMIN_ROLE";
    AccessControlRoleType["MINTER_ROLE"] = "MINTER_ROLE";
    AccessControlRoleType["PAUSER_ROLE"] = "PAUSER_ROLE";
    AccessControlRoleType["PREDICATE_ROLE"] = "PREDICATE_ROLE";
    AccessControlRoleType["DEPOSITOR_ROLE"] = "DEPOSITOR_ROLE";
    AccessControlRoleType["METADATA_ROLE"] = "METADATA_ROLE";
})(AccessControlRoleType || (exports.AccessControlRoleType = AccessControlRoleType = {}));
var AccessControlRoleHash;
(function (AccessControlRoleHash) {
    AccessControlRoleHash["DEFAULT_ADMIN_ROLE"] = "0x0000000000000000000000000000000000000000000000000000000000000000";
    AccessControlRoleHash["MINTER_ROLE"] = "0x9f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a6";
    AccessControlRoleHash["PAUSER_ROLE"] = "0x65d7a28e3265b37a6474929f336521b332c1681b933f6cb9f3376673440d862a";
    AccessControlRoleHash["PREDICATE_ROLE"] = "0x12ff340d0cd9c652c747ca35727e68c547d0f0bfa7758d2e77f75acef481b4f2";
    AccessControlRoleHash["DEPOSITOR_ROLE"] = "0x8f4f2da22e8ac8f11e15f9fc141cddbb5deea8800186560abb6e68c5496619a9";
    AccessControlRoleHash["METADATA_ROLE"] = "0x6bd6b5318a46e5fff572d5e4258a20774aab40cc35ac7680654b9081fcc82f80";
})(AccessControlRoleHash || (exports.AccessControlRoleHash = AccessControlRoleHash = {}));
//# sourceMappingURL=access-control.js.map